<template>
  <div
    class="relative w-full h-full page not-found"
  >
    <mia-by-the-road-illustration
      class="absolute bottom-0 left-0 w-0 md:w-1/4 lg:w-1/5 xl:w-1/6"
    />
    <mia-off-road-illustration class="absolute bottom-0 right-0 off-road" />
    <div class="absolute inset-0 flex flex-col items-center w-full h-full error-description">
      <div class="flex flex-col max-w-xl text-center white-shadow">
        <h2 class="text-6xl font-bold">
          <span class="mr-2 text-gray-800">4</span>
          <span class="mr-2 text-orange-mia">0</span>
          <span class="mr-2 text-gray-800">4</span>
        </h2>
        <p class="text-2xl leading-8 text-gray-600">
          Wie es aussieht haben Sie sich verfahren.
        </p>
        <p class="text-2xl leading-8 text-gray-600">
          Klicken Sie <a
            href="/"
            class="hover:underline"
          >hier</a>, um zurück zur Startseite zu gelangen.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ByTheRoad from '@/assets/svg/illustrations/ByTheRoad.vue'
import OffRoad from '@/assets/svg/illustrations/OffRoad.vue'

export default {
  components: {
    'mia-by-the-road-illustration': ByTheRoad,
    'mia-off-road-illustration': OffRoad
  },
  mounted() {
    eventBus.$emit('mia-loading-ended')
  }
}
</script>
<style lang="scss">
.not-found {
  margin: -0.5rem;
  width: calc(100% + 1rem);
  height: calc(100% + 1rem);
}
.white-shadow {
  text-shadow: 0px 0px 3px #FFFFFF;
}
.off-road {
  @apply w-full;
  @screen sm {
    @apply w-2/3;
  }
  @screen md {
    @apply w-1/2;
  }
  @media screen and (max-width: 1024px) and (max-height: 520px) {
    @apply w-0;
  }
  @screen lg {
    @apply w-1/3;
  }
  @screen xl{
    @apply w-1/4;
  }
}
.error-description {
  @media only screen and (min-height: 717px){
    @apply justify-center;
  }
}
</style>
